export default {
    patchNote: "Patch Notes",
}